// extracted by mini-css-extract-plugin
export var closed = "_b5-1";
export var resizer = "_b5-0";